__turbopack_context__.v({
  "content": "error-module-scss-module__5C4lWq__content",
  "content__description": "error-module-scss-module__5C4lWq__content__description",
  "content__reloadButton": "error-module-scss-module__5C4lWq__content__reloadButton",
  "content__title": "error-module-scss-module__5C4lWq__content__title",
  "wrapper": "error-module-scss-module__5C4lWq__wrapper",
});
